export var apiURL = {
  API_COMETA: '/api/cometa',
  API_COMETA_SIC_NAICS: '/api/cometa/sic-naics',
  API_ENUMS: '/api/enums'
};